<div class="col text-left h-100">
  <div class="header-opening">
    <span class="primary">
      {{ companyTagline }}
    </span>
    <span *ngIf="todayWorkingHours && todayWorkingHours.fromTime && todayWorkingHours.toTime">{{ 'OPEN TODAY' | translate }} {{ todayWorkingHours.openHours | translate }}</span>
    <span *ngIf="!todayWorkingHours || (todayWorkingHours.toTime === 0 && todayWorkingHours.fromTime === 0)" class="closed">
    {{ 'Closed' | translate }}</span>
  </div>
</div>
